import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    TextField,
} from "@mui/material";

type AlertProps = {
    label: string,
    open: boolean,
    setOpen: (v: boolean) => void,
    description: string,
    disabled?: boolean,
    setText?: (v: string) => void,
    handleAgree?: () => void,
    agreeText?: string,
}

const FormAlert = ({
    label,
    open,
    setOpen,
    description,
    disabled = false,
    setText,
    handleAgree,
    agreeText
}: AlertProps) => {
    const handleClose = () => {
        if (setText) {
            setText("");
        }
        setOpen(false);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-labelledby={`${label}-title`}
                aria-describedby={`${label}-description`}
            >
                <DialogContent>
                    <DialogContentText id={`${label}-description`} paddingBottom={setText ? 2 : 0}>
                        {description}
                    </DialogContentText>
                    {setText &&
                        <TextField
                            fullWidth
                            label={"Message"}
                            disabled={disabled}
                            onChange={(e) => { setText(e.target.value) }}
                        />
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={disabled}>Close</Button>
                    {handleAgree &&
                        <Button onClick={handleAgree} disabled={disabled}>
                            {agreeText}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FormAlert;
